module.exports = __webpack_public_path__ + "static/media/8800.1b640b99.jpg";